import { NgModule } from '@angular/core';
import { UserModule } from 'src/app/user/user.module';
import { MaterialUiModule } from 'src/app/layout/material-ui/material-ui.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientRoutingModule } from './client-routing.module';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { MatProgressBarModule, MatSnackBarModule, MatTabsModule } from '@angular/material';
import { ConvenioClientComponent } from './convenio-client/convenio-client.component';
import { ResumoClientComponent } from './resumo-client/resumo-client.component';
import { HorariosClientComponent } from './horarios-client/horarios-client.component';
import { MinhaAgendaClientComponent } from './minha-agenda-client/minha-agenda-client.component';
import { CancelaAgendaClientComponent } from './cancela-agenda-client/cancela-agenda-client.component';
import { AgendamentostepperClientComponent } from './agendamentostepper-client/agendamentostepper-client.component';
import { ProcedimentoClientComponent } from './procedimento-client/procedimento-client.component';
import { PagamentoClientComponent } from './pagamento-client/pagamento-client.component';
import { MessageBoxComponent } from '../components/message-box/message-box.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { DialogPesoComponent } from './dialog-peso/dialog-peso.component';
import { AnexoComponent } from '../components/anexo/anexo.component';
import { AgendamentoLoginPrimeiroComponent } from './agendamento-tipos/agendamento-login-primeiro/agendamento-login-primeiro.component';
import { AgendamentoConvenioPrimeiroComponent } from './agendamento-tipos/agendamento-convenio-primeiro/agendamento-convenio-primeiro.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PixPaymentComponent } from './pix-payment/pix-payment.component';

// export const maskConfigFunction: () => Partial<IConfig> = () => {
//   return {
//     validation: false,
//   };
// };

@NgModule({
  declarations: [
    ConvenioClientComponent,
    ResumoClientComponent,
    HorariosClientComponent,
    MinhaAgendaClientComponent,
    CancelaAgendaClientComponent,
    AgendamentostepperClientComponent,
    ProcedimentoClientComponent,
    PagamentoClientComponent,
    MessageBoxComponent,
    NotificationsComponent,
    AnexoComponent,
    AutoLoginComponent,
    DialogPesoComponent,
    AgendamentoLoginPrimeiroComponent,
    AgendamentoConvenioPrimeiroComponent,
    PixPaymentComponent,
  ],
  imports: [
    CommonModule,
    ClientRoutingModule,
    MaterialUiModule,
    FormsModule,
    ReactiveFormsModule,
    UserModule,
    NgxMaskModule.forRoot(),
    MatSnackBarModule,
    MatTabsModule,
    MatProgressBarModule,
  ],
  exports: [
    AnexoComponent,
    MessageBoxComponent
  ],
  entryComponents: [
    DialogPesoComponent,
  ]
})
export class ClientModule { }
